import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import "./_Options.css";


const FormsTrapPgs = React.FC = () => {
    return (
        <div>
            <p className="h4 text-white">Estimativa para Larva/Pupa/Mosquitos</p>
            <select className="form-control" >
                <option value={true}>Sim</option>
                <option value={false}>Não</option>
            </select>
        </div>
    );
}

export default FormsTrapPgs;